/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IProductDetailContainerData } from './product-detail-container.data';
import { IProductDetailContainerProps } from './product-detail-container.props.autogenerated';

export interface IProductDetailContainerViewProps extends IProductDetailContainerProps<IProductDetailContainerData> {
    details: React.ReactNode[];
    availability: React.ReactNode[];
    customClass: string;
}

/**
 *
 * ProductDetailContainer component
 * @extends {React.PureComponent<IProductDetailContainerProps<IProductDetailContainerData>>}
 */
class ProductDetailContainer extends React.PureComponent<IProductDetailContainerProps<IProductDetailContainerData>> {
    public render(): JSX.Element | null {
        const viewProps= {
            ...this.props,
            availability: this.props.slots.availabilityContainer,
            details: this.props.slots.productDetailBlock,
            customClass: this.props.config.className ? this.props.config.className : ''
        };

        return this.props.renderView(viewProps) as React.ReactElement;
    }
}

export default ProductDetailContainer;
